exports.linkResolver = (doc) => {
  if (doc.type) {
    if (doc.type === 'blog') {
      return `/blog/${doc.uid}`;
    }

    if (doc.type === 'work') {
      return `/work/${doc.uid}`;
    }

    if (doc.type === 'community-impact') {
      return `/community-impact/${doc.uid}`;
    }

    if (doc.type === 'people') {
      return `/people/${doc.uid}`;
    }

    if (doc.type === 'approach' && typeof doc.link_type === 'undefined') {
      return `/approach/${doc.data.approach_category.slug}/${doc.uid}`;
    }

    if (doc.type === 'careers') {
      return `/careers/${doc.uid}`;
    }

    if (doc.type && doc.type.includes('_main_page')) {
      return `/${doc.uid}`;
    }
  }

  return '/';
};
